/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {Directive} from '@angular/core';


/** Prefix to be placed the the front of the form field. */
@Directive({
  selector: '[matPrefix]',
})
export class MatPrefix {}
